import { FC, useState, useEffect, useMemo, useRef, useContext } from 'react';
import { useMethods } from '@lhb/hook';
import { downloadFile, isNotEmpty } from '@lhb/func';
import { getCookie } from '@lhb/cache';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography, Form, Modal } from 'antd';
// import { bigdataBtn } from '@/common/utils/bigdata';
import { exportModelClusterPDFAsync, handleDeleteCustom, updateAreaDetailInfo } from '@/common/api/siteselectionmap';
import { ARE_AREPORT_CONTAINER_CLASS, AreaReportModule, ChildreClass } from '@/views/pdf/pages/areareport/ts-config';
import { buildXtcReportUrls, XTC_REPORT_BTN_FORCE_SHOW, forceShowPerm } from '@/common/utils/xtcReportUrl';
import cs from 'classnames';
import styles from './index.module.less';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
// import IconFont from '@/common/components/IconFont';
import LabelRow from '../LabelRow';
import DataInfoModal from './DataInfoModal';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import { useBigdataFn } from '@/common/utils/bigdata';
import { getSiteModelList } from '@/common/api/networkplan';
import UserInfoContext from '@/layout/context';
import { globalExpansionTaskAlias, globalOpeningAreaAlias } from '@/common/utils/ways';
import GatherClientDrawer from '../GatherClientDrawer';
import Share from './Share';
import CreateTask from './CreateTask';
import EditFormModal from './EditFormModal';
// import Entrance from '../../../LeftContent/DistrictDimension/RightCon/PointDetailDrawer/CreateFavorite/Entrance';
// import { newPointStatusEnum } from '../../../../ts-config';
import IconFont from '@/common/components/IconFont';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import { getShareId } from '@/common/api/common';
import Entrance from '@/views/youth/pages/map/components/LeftContent/DistrictDimension/RightCon/PointDetailDrawer/CreateFavorite/Entrance';
import { newPointStatusEnum } from '@/views/youth/pages/map/ts-config';
import AreaMarking from '@/common/components/business/YouthMap/Common/AreaMarking';
import AreaMarkingModal from '@/common/components/business/YouthMap/Common/AreaMarkingModal';
import { usePageTitle } from '@/common/hook/usePageTitle';
import { getRadiusByRangeType } from '../FirstScreenRight/ts-config';
import { useCurrentUserInfo } from '@/common/hook/useCurrentUserInfo';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import AllTaskDetailDrawer, { AllTaskDetailDrawerData } from '@/views/expandstore/pages/expansiontask/components/AllTaskDetailDrawer';
import { TaskStatus } from '../../ts-config';
import { useSelector } from 'react-redux';
import { kaXTC } from '@/ka/xtc/config';

// 20261029 https://confluence.lanhanba.com/pages/viewpage.action?pageId=172107639
const deleteKey = 'modelCluster:delete'; // 'delete';

const { Text } = Typography;

/**
 * @Description 商圈详情头部部分
 */
const Top: FC<{
  id,
  detail,
  rank,
  showCollect,
  hideTopActions,
  /** 标签编辑后回调 */
  onLabelChanged,
  labelOptionsChanged,
  /** pdf状态 */
  pdfDataStatus,
  /** 轮训接口, */
  getPDFStatus,
  /** 刷新 */
  onRefreshGather,
  /** 创建拓店任务按钮权限 */
  createTaskPermission,
  /** 拓店任务历史按钮权限 */
  historyTaskPermission,
  /** 拓店任务历史 */
  setHistoryVisible,
  /** 创建拓店任务抽屉 */
  setShowCreateDrawer,
  overViewData,
  /** 集客点按钮展示权限与状态 */
  gatherClientPoint,
  getDetail,
  setEditModalData,
  editModalData,
  modelConfigId,
  setIsReset,
  setDrawerData,
  rangeType,
  isSemirModel, // 是否是森马模型
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI, // AI分析
  agentTenantData,
  setDetail,
  onAreaNameEdited,
}> = ({
  id,
  detail,
  rank,
  showCollect,
  hideTopActions = false,
  onLabelChanged, // 标签编辑后回调
  labelOptionsChanged,
  pdfDataStatus, // pdf状态
  getPDFStatus, // 轮训接口,
  onRefreshGather, // 刷新
  createTaskPermission, // 创建拓店任务按钮权限
  historyTaskPermission, // 拓店任务历史按钮权限
  setHistoryVisible, // 拓店任务历史
  setShowCreateDrawer, // 创建拓店任务抽屉
  overViewData,
  gatherClientPoint, // 集客点按钮展示权限与状态
  getDetail,
  setEditModalData,
  editModalData,
  modelConfigId,
  setIsReset,
  setDrawerData,
  rangeType,
  isSemirModel = false,
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI,
  agentTenantData,
  setDetail,
  onAreaNameEdited,
}) => {
  const defaultConfig = useSelector((state: any) => state.youth.defaultConfig);
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const { isFavourate } = detail;
  const intervalRef: any = useRef();
  const {
    /* 当前用户信息 */
    currentUserInfo,
  } = useCurrentUserInfo();
  const [openDataInfo, setOpenDataInfo] = useState(false); // 打开数据说明弹窗
  const [collectStatus, setCollectStatus] = useState(isFavourate);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  const [gatherClientPointDrawer, setGatherClientPointDrawer] = useState<any>({
    visible: false,
    value: {}
  });// 集客点抽屉
  const [expandStoreDrawerData, setExpandStoreDrawerData] = useState<AllTaskDetailDrawerData>({
    visible: false,
    id: null
  });
  const [editAreaNameVisible, setEditAreaNameVisible] = useState(false); // 编辑商圈名称弹窗
  const [editAreaNameForm] = Form.useForm();
  const editAreaNameInputRef = useRef<any>();
  // 不合适标记弹窗状态
  const [markingModal, setMarkingModal] = useState<{ open: boolean; data: { modelClusterId: number | null; [p: string]: any } }>({ open: false, data: { modelClusterId: null, areaName: '' } });
  const { tenantInfo, id: userId } = useContext(UserInfoContext); // 租户信息
  const { tenantCheckInfo } = useTenantCheckInfo(); // 租户检查信息
  const isXTC = kaXTC(tenantCheckInfo); // 使用kaXTC不需要传tenantCheckInfo的，这里是为了兼容历史逻辑
  const { globalAliasItemVOs } = tenantInfo;
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);
  const openingAreaAlias = globalOpeningAreaAlias(globalAliasItemVOs);
  const { name: menuName } = usePageTitle();

  const exportPermission = useMemo(() => { // 导出报告按钮权限
    // return detail?.permissions?.find((item) => item.event === 'siteselectionmapb:export');
    return true; // 0821 导出报告不做按钮权限
  }, [detail?.permissions]);
  const showDownloadBtn = useMemo(() => { // 显示下载报告按钮
    const { exportStatus, name, url } = pdfDataStatus || {};
    return exportStatus === 2 && name && url;
  }, [pdfDataStatus]);
  const editPermission = useMemo(() => { // 编辑权限
    return detail?.permissions?.find((item) => item.event === 'youth:editCluster');
  }, [detail?.permissions]);

  const editAreaNamePermission = useMemo(() => { // 编辑商圈名称权限
    return detail?.permissions?.find((item) => item.event === 'appYouthMap:customModelClusterName');
  }, [detail?.permissions]);

  /* 这块参数只有小天才租户使用 start */
  // 抽屉当前展示的是 Mall（小圈/资源库商场）还是商圈（大圈）：决定显示 项目报告 还是 商圈报告 入口
  const isMallType = useMemo(() => !!detail?.resourceMallFlag, [detail?.resourceMallFlag]);
  // 小天才商圈报告（大圈）：查看权限 — 仅商圈详情显示
  const viewXtcMallPerm = useMemo(() => {
    if (XTC_REPORT_BTN_FORCE_SHOW) return forceShowPerm('xtcReport:mall:view', '查看商圈报告');
    return detail?.permissions?.find((item) => item.event === 'xtcReport:mall:view');
  }, [detail?.permissions]);
  // 小天才商圈报告：导出权限
  const exportXtcMallPerm = useMemo(() => {
    if (XTC_REPORT_BTN_FORCE_SHOW) return forceShowPerm('xtcReport:mall:export', '导出商圈报告');
    return detail?.permissions?.find((item) => item.event === 'xtcReport:mall:export');
  }, [detail?.permissions]);
  // 小天才商圈报告：导出 loading 状态
  const [isExportingXtcMall, setIsExportingXtcMall] = useState<boolean>(false);
  // 小天才项目报告（小圈/Mall）：查看权限 — 仅 Mall 详情显示
  const viewXtcProjectPerm = useMemo(() => {
    if (XTC_REPORT_BTN_FORCE_SHOW) return forceShowPerm('xtcReport:project:view', '查看项目报告');
    return detail?.permissions?.find((item) => item.event === 'xtcReport:project:view');
  }, [detail?.permissions]);
  // 小天才项目报告：导出权限
  const exportXtcProjectPerm = useMemo(() => {
    if (XTC_REPORT_BTN_FORCE_SHOW) return forceShowPerm('xtcReport:project:export', '导出项目报告');
    return detail?.permissions?.find((item) => item.event === 'xtcReport:project:export');
  }, [detail?.permissions]);
  // 小天才项目报告：导出 loading 状态
  const [isExportingXtcProject, setIsExportingXtcProject] = useState<boolean>(false);

  // 小天才报告导出 loading 接到生成状态（对齐非小天才 isExporting / 图1：点击后持续转圈直到导出成功）。
  // 后端 exportStatus：1 未导出 / 2 导出完成 / 3 导出中。生成中(3)→ 持续「正在导出报告」转圈；导出完成(2)→ 停。
  // 点击时导出方法内已置 true 覆盖「触发接口 → 后端置生成中」的空窗；此处仅在 2/3 校正，未导出(1)不动以保留点击后的 true。
  useEffect(() => {
    const { exportStatus } = pdfDataStatus || {};
    if (exportStatus === 3) {
      setIsExportingXtcMall(true);
      setIsExportingXtcProject(true);
    } else if (exportStatus === 2) {
      setIsExportingXtcMall(false);
      setIsExportingXtcProject(false);
    }
  }, [pdfDataStatus]);
  /* 这块参数只有小天才租户使用 end */

  const showDelete = useMemo(() => {
    // 有删除权限
    const permission = detail?.permissions?.some((item) => item.event === deleteKey);
    // 不在审核中
    const isReview = detail?.reviewStatus !== newPointStatusEnum.IN_REVIEW;
    return permission && isReview;
  }, [detail]);

  // 拓店任务配置
  const taskConfigObj = useMemo(() => {

    return {
      isTaskProcessing: [TaskStatus.PROCESSING].includes(detail?.taskStatus), // 拓店任务是否进行中;
      disabled: TaskStatus.DESIGNATE === detail?.taskStatus, // 没有taskId或者任务待指派的时候禁用按钮
      btnTitle: [TaskStatus.PROCESSING, TaskStatus.PROCESSING].includes(detail?.taskStatus) ? `${expansionTaskAlias || '任务'}进行中` : `发起${expansionTaskAlias || '拓店'}`, // 按钮标题保持原有逻辑
    };
  }, [detail?.taskStatus, detail?.taskId]);
  // 是否展示AI解读分析按钮
  const showAIButton = useMemo(() => {
    return !!agentTenantData;
  }, [agentTenantData]);

  useEffect(() => {
    const { exportStatus } = pdfDataStatus || {};
    if (exportStatus === 3) {
      setIsExporting(true);
      if (intervalRef.current) return; // 如果还未创建定时器说明是第一次进来
      setProgress(99);
    } else {
      setIsExporting(false);
      setProgress(0);
      if (!intervalRef.current) return;
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [pdfDataStatus]);

  useEffect(() => {
    setCollectStatus(!!detail?.isFavourate);
  }, [detail]);

  const methods = useMethods({
    jumpToTarget: () => {
      const { servicePlaceId } = detail;
      if (!servicePlaceId) {
        V2Message.warning('数据异常，未获取到资源id');
        return;
      }
      // bigdataBtn('abcfb807-a1f8-4aaf-9db9-6ab09f9546b5', '选址地图', '商圈详情-案例及订单', '点击商圈详情-案例及订单');
      window.open(`${process.env.LINHUIBA_ADMIN}lhb-micro-pms/placeMng/detail?tenantPlaceId=${servicePlaceId}`);
    // https://lhb.lanhanba.com/#/lhb-micro-pms/placeMng/detail?tenantPlaceId=40474
    },
    exportPDF: async () => {
      const tenantId = getCookie('tenantId') || tenantInfo?.id;
      const employeeId = getCookie('employeeId') || userId;
      setIsExporting(true);
      intervalRef.current = setInterval(() => {
        if (progress === 99) {
          intervalRef.current && clearInterval(intervalRef.current);
          return;
        }
        setProgress((state) => {
          if (state < 95) return state + 5;
          return 99;
        });
      }, 600);
      let targetModelConfigId = modelConfigId;
      if (!targetModelConfigId || +targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = data[0]?.id || 0;
      }
      // 兜底，防止机会点所属商圈组件在引用该详情时，没有配置选址地图模型
      if (!targetModelConfigId) {
        V2Message.warning(`请先配置选址地图模型！`);
        return;
      }
      const waterText = currentUserInfo.mobile ? `${currentUserInfo.name} ${currentUserInfo.mobile.slice(-4)}` : currentUserInfo.name;
      getShareId({
        // 和app分享统一链接
        longLinkUrl: `${process.env.CONSOLE_PC_URL}/share/youth`,
        content: JSON.stringify({
          id: detail.id,
          modelConfigId: targetModelConfigId,
          tenantId,
          globalAliasItemVOs,
          reportLogo: tenantInfo.standardChancePointReportLogo,
          employeeId,
          waterText,
          modelClusterInfo: !!defaultConfig?.modelClusterInfo,
          // isSemirModel
        }),
        expirationDate: null, // 代表永不失效
        expirationRedirectUrl: `${process.env.CONSOLE_PC_URL}/share/failure`,
        needToken: true,
      }).then(async (res: any) => {
        const shareUrl = res.frontShareLinkUrl;
        const params = {
          // name: detail.areaName || '商圈报告',
          name: `${detail.areaName || '商圈报告'}.pdf`,
          type: 1, // 导出类型：1:商圈 2:机会点
          id: detail.id,
          menuName,
          nodeData: {
            name: `${detail.areaName || '商圈报告'}.pdf`,
            options: [
              { // 定制化模块，并合并至最终的pdf里
                url: [
                  `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_1}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}&rangeType=${rangeType}&rangeValue=${getRadiusByRangeType(rangeType)}&shareUrl=${shareUrl}&mapDataType=youthMapData&modelClusterInfo=${!!defaultConfig?.modelClusterInfo}`,
                  `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_2}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}&rangeType=${rangeType}&rangeValue=${getRadiusByRangeType(rangeType)}&shareUrl=${shareUrl}&mapDataType=youthMapData&modelClusterInfo=${!!defaultConfig?.modelClusterInfo}`,
                  `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_3}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}&rangeType=${rangeType}&rangeValue=${getRadiusByRangeType(rangeType)}&shareUrl=${shareUrl}&mapDataType=youthMapData&modelClusterInfo=${!!defaultConfig?.modelClusterInfo}&`,
                ],
                containerClass: ARE_AREPORT_CONTAINER_CLASS,
                childClass: ChildreClass,
              // delay: 1500, // 延迟截图
              }
            ],
            waterMark: waterText,
            needPageTable: true,
          },
        };
        // bigdataFn('a96c7a51-a3d9-4b36-bd17-fc89dd215cb9', '详情-导出报告', '点击了详情-导出报告', { op_block: '开店区域-详情页', op_event: `${detail.cityName}-${detail.areaName}`, });
        // 接口异步下载
        await exportModelClusterPDFAsync(params).finally(() => {
          // setIsExporting(false);
          // setShowHintModal(true);
          V2Message.success('报告正在生成中，请稍后查看');
          // 轮训状态
          getPDFStatus && getPDFStatus();
        });
      });
    },
    handleDownload: () => {
      // bigdataFn('c8eac377-19d3-4ff6-8ebd-fd668efcfbd0', '详情-查看报告', '点击了详情-查看报告', { op_block: '开店区域-详情页', op_event: `${detail.cityName}-${detail.areaName}`, });
      const { name, url } = pdfDataStatus;
      downloadFile({
        name,
        url: `${process.env.STATIC_RES_DOMAIN}//libs/preview-pdf/web/viewer.html?file=${encodeURIComponent(url)}&fixname=` + encodeURIComponent(`${name}`)
      });
    },
    openExpandStoreDetail() {
      setExpandStoreDrawerData({
        id: detail.taskId,
        visible: true,
      });
    },
    onCreateSuccess() {
      if (taskConfigObj.isTaskProcessing) {
        setExpandStoreDrawerData({
          id: detail.taskId,
          visible: true,
        });
      } else {
        getDetail();
      }
    },
    handleEditAreaName() {
      // 打开弹窗并回填当前名称，100ms 后聚焦到末尾
      setEditAreaNameVisible(true);
      editAreaNameForm.setFieldValue('areaName', detail.areaName);
      setTimeout(() => {
        editAreaNameInputRef.current?.focus({ cursor: 'end' });
      }, 100);
    },
    async handleEditAreaNameOk() {
      try {
        const values = await editAreaNameForm.validateFields();
        await updateAreaDetailInfo({ modelClusterId: detail.id, customName: values.areaName });
        // 埋点,一定要放在setDetail前面
        bigdataFn('f47dea04-1cd4-4da5-a2e4-ffcc9c09863f', '编辑商圈名称', '修改商圈名称', { op_block: '商圈名称修改', op_event: `商圈名称由：${detail.areaName}，修改为${values.areaName}`, });
        // 局部更新 detail.areaName，不重新请求接口
        setDetail?.((prev: any) => ({ ...prev, areaName: values.areaName }));
        // 通知父组件名称已被编辑
        onAreaNameEdited?.(values.areaName);
        setEditAreaNameVisible(false);
        V2Message.success('名称修改成功');
      } catch (error) {
        console.log(error);
      }
    },
    handleEditAreaNameCancel() {
      setEditAreaNameVisible(false);
    },

    /* 小天才专用的方法 start */
    // 小天才项目报告（Mall 单圈）：查看 → 打开导出生成的 PDF 文件（OSS url，复用老「查看报告」handleDownload），非在线 /pdf 预览（#54）
    viewXtcProjectReport: () => {
      const { name, url } = pdfDataStatus || {};
      if (!url || !name) {
        V2Message.warning('报告尚未生成，请先导出');
        return;
      }
      downloadFile({
        name,
        url: `${process.env.STATIC_RES_DOMAIN}//libs/preview-pdf/web/viewer.html?file=${encodeURIComponent(url)}&fixname=` + encodeURIComponent(`${name}`)
      });
    },
    // 小天才项目报告：导出 → 复用 exportModelClusterPDFAsync 走 puppeteer 异步链路
    exportXtcProjectReport: async () => {
      const token = getCookie('flow_token');
      if (!token) {
        V2Message.error('登录态失效，请重新登录');
        return;
      }
      const tenantId = getCookie('tenantId') || tenantInfo?.id;
      const employeeId = getCookie('employeeId') || userId;
      if (!detail?.id || !modelConfigId) {
        V2Message.warning('数据未就绪，请稍后再试');
        return;
      }
      setIsExportingXtcProject(true);
      const urlList = buildXtcReportUrls('project', {
        id: detail.id,
        modelConfigId,
        tenantId,
        employeeId,
      }).map((u) => `${process.env.CONSOLE_PC_URL}${u}`);
      const params = {
        name: `${detail.areaName || 'Mall'}-市调评估报告.pdf`,
        type: 1,
        id: detail.id,
        menuName,
        nodeData: {
          name: `${detail.areaName || 'Mall'}-市调评估报告.pdf`,
          tag: 'xtcProjectReport',
          options: [
            {
              url: urlList,
              containerClass: 'business-area-pdf',
              childClass: 'business-item-pdf',
            }
          ],
          needPageTable: true,
        },
      };
      await exportModelClusterPDFAsync(params)
        .then(() => {
          V2Message.success('项目报告正在生成中，生成后可点「查看项目报告」');
          // 启动状态轮询，导出完成后「查看」按钮自动出现。
          // 不在此清 loading：保持「正在导出报告」持续转圈，由轮询(exportStatus)驱动——导出完成(2)才停（图1 持续转到成功）。
          getPDFStatus && getPDFStatus();
        })
        .catch((e) => {
          V2Message.error(e?.message || '导出失败，请稍后再试');
        })
        .finally(() => {
          // 触发失败 → 停转圈（生成阶段的停由上方 pdfDataStatus useEffect 接管）
          setIsExportingXtcProject(false);
        });
    },
    // 小天才商圈报告：查看 → 打开导出生成的 PDF 文件（OSS url，复用老「查看报告」handleDownload），非在线 /pdf 预览（#54）
    viewXtcMallReport: () => {
      const { name, url } = pdfDataStatus || {};
      if (!url || !name) {
        V2Message.warning('报告尚未生成，请先导出');
        return;
      }
      downloadFile({
        name,
        url: `${process.env.STATIC_RES_DOMAIN}//libs/preview-pdf/web/viewer.html?file=${encodeURIComponent(url)}&fixname=` + encodeURIComponent(`${name}`)
      });
    },
    // 小天才商圈报告：导出 → 复用 exportModelClusterPDFAsync 走 puppeteer 异步链路
    exportXtcMallReport: async () => {
      const token = getCookie('flow_token');
      if (!token) {
        V2Message.error('登录态失效，请重新登录');
        return;
      }
      const tenantId = getCookie('tenantId') || tenantInfo?.id;
      const employeeId = getCookie('employeeId') || userId;
      if (!detail?.id || !modelConfigId) {
        V2Message.warning('数据未就绪，请稍后再试');
        return;
      }
      setIsExportingXtcMall(true);
      const urlList = buildXtcReportUrls('mall', {
        id: detail.id,
        modelConfigId,
        tenantId,
        employeeId,
      }).map((u) => `${process.env.CONSOLE_PC_URL}${u}`);
      const params = {
        name: `${detail.areaName || '商圈'}-市调评估报告.pdf`,
        type: 1, // 复用商圈类型；后端可按 nodeData.tag 区分小天才模板
        id: detail.id,
        menuName,
        nodeData: {
          name: `${detail.areaName || '商圈'}-市调评估报告.pdf`,
          tag: 'xtcMallReport',
          options: [
            {
              url: urlList,
              containerClass: 'business-area-pdf',
              childClass: 'business-item-pdf',
            }
          ],
          needPageTable: true,
        },
      };
      await exportModelClusterPDFAsync(params)
        .then(() => {
          V2Message.success('商圈报告正在生成中，生成后可点「查看商圈报告」');
          // 启动状态轮询，导出完成后「查看」按钮自动出现。
          // 不在此清 loading：保持「正在导出报告」持续转圈，由轮询(exportStatus)驱动——导出完成(2)才停（图1 持续转到成功）。
          getPDFStatus && getPDFStatus();
        })
        .catch((e) => {
          V2Message.error(e?.message || '导出失败，请稍后再试');
        })
        .finally(() => {
          // 触发失败 → 停转圈（生成阶段的停由上方 pdfDataStatus useEffect 接管）
          setIsExportingXtcMall(false);
        });
    },
    /* 小天才专用的方法 end */
  });
  const handleClick = async() => {
    const _data = await handleDeleteCustom({
      clusterId: id,
      onlyCheck: true// 是否仅检查有无业务关系
    });
    // 返回true，表示没有业务数据，可以删除
    if (_data) {
      handleDelete();
    }
  };

  const handleDelete = () => {
    V2Confirm({
      onSure: (modal: any) => {
        onDelete(modal);
      },
      content: `删除后，此${openingAreaAlias}无法找回`
    });
  };
  const onDelete = (modal: any) => {
    handleDeleteCustom({
      clusterId: id,
    }).then(() => {
      setIsReset?.((state) => state + 1);
      setDrawerData({
        open: false,
        id: '',
        rankVal: null
      });
      // 埋点
      bigdataFn('27bce3ce-a158-415b-b1c3-a214c21787ef', '商圈删除', '确认后删除', { op_block: '商圈删除', op_event: `商圈删除`, });
    }).finally(() => {
      modal.destroy();
    });
  };

  const showDataDescriptionFlag = useMemo(() => {
    // 1：默认值，2：自定义富文本，3：不展示
    // 如果没有这个参数，也就是没设置过，就沿用老逻辑展示默认值。
    if (!isNotEmpty(detail.showDataDescriptionFlag)) {
      return 1;
    } else {
      return detail.showDataDescriptionFlag;
    }
  }, [detail.showDataDescriptionFlag]);

  return (
    <div className={styles.topCon}>
      <div className={styles.titleRow}>
        {/* 标题+编辑图标 inline-flex 容器，编辑按钮始终可见 */}
        <div className={styles.tit}>
          <Text
            style={{ flex: 1, minWidth: 0 }}
            ellipsis={{ tooltip: detail.areaName }}>
            <span className='fs-20 c-222 bold'>
              {rank ? `${rank}.` : ''}
              {detail.areaName}
            </span>
          </Text>
          {/* 有权限才展示编辑图标 */}
          {!hideTopActions && editAreaNamePermission && (
            <IconFont
              iconHref='pc-common-icon-ic_edit'
              className='fs-18 pointer ml-2'
              style={{ flexShrink: 0 }}
              onClick={methods.handleEditAreaName}
            />
          )}
        </div>
        {!hideTopActions && <div className={styles.flexCon}>
          {
            // 如果没有这个参数，也就是没设置过，就沿用老逻辑展示。
            // 或者选择了1展示默认，或者2展示自定义，也显示，只有值为3：不展示，才不显示
            [1, 2].includes(showDataDescriptionFlag) && (
              <div className={styles.targetOffset} onClick={() => {
                setOpenDataInfo(true);
                // bigdataFn('ed2fc180-68e0-4912-80cf-1bb5cd3e7550', '详情-数据说明', '点击了详情-数据说明', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
              }}>
                <div className='fs-12 c-666 rt'>
                  <span className='pr-4'>数据说明</span>
                  <QuestionCircleOutlined />
                </div>
              </div>
            )
          }
          {/* 商圈打标 */}
          <AreaMarking
            itemData={overViewData}
            areaName={detail.areaName}
            width={32}
            height={32}
            imgWidth={12}
            imgHeight={12}
            onOpenModal={(markId: number) => setMarkingModal({ open: true, data: { modelClusterId: markId, areaName: detail.areaName } })}
            showTooltip={false}
            onStatusChange={getDetail}
            className={styles.areaMarkCon}
          />
          {
            showCollect ? <Entrance
              clusterId={id}
              collectStatus={collectStatus}
              setCollectStatus={setCollectStatus}
              wrapperClassName={styles.favourBtn}
              iconClassName='fs-14'
              isLarge
              modelConfigId={modelConfigId}
              collectEventFn={() => {
                // bigdataFn('98b8a86c-2c6b-4882-add2-82a39c824ff3', '详情-收藏', '点击了详情-收藏', { op_block: '开店区域-详情页', op_event: ``, });
              }}
            /> : <></>
          }
          {/* 删除按钮 */}
          {
            showDelete ? <Tooltip title={'删除'} >
              <div className={styles.delete} onClick={handleClick}>
                <IconFont
                  iconHref={'icondelete'}
                  className='fs-14'
                />
              </div>
            </Tooltip> : <></>
          }
          {/* 分享 */}
          <Share
            modelConfigId={modelConfigId}
            id={detail.id}
            globalAliasItemVOs={globalAliasItemVOs}
            tenantInfo={tenantInfo}
            userId={userId}
            areaName={detail.areaName}
            rangeType={rangeType}
            // isSemirModel={isSemirModel}
          />
          {/* 导出商圈报告PDF：老链路按钮仅非小天才租户展示，小天才租户走新 xtcReport 按钮 */}
          {
            !isXTC && exportPermission
              ? <>
                {/* {
                  showDownloadBtn
                    ? <div className='c-006 pointer ml-8 ml-8 fs-14' onClick={methods.handleDownload}>查看报告</div> : <></>
                } */}
                {
                  showDownloadBtn
                    ? <Button
                      onClick={methods.handleDownload}
                      className='ml-8'
                    >
                    查看报告
                    </Button> : <></>
                }

                <Button
                  loading={isExporting}
                  onClick={methods.exportPDF}
                  disabled={pdfDataStatus?.exportStatus === 3}
                  // 当存在集客点录入按钮时，集客点为primary，其余为default
                  type={gatherClientPoint?.permissionConfig?.isPermission || createTaskPermission ? 'default' : 'primary'}
                  className='inline-block ml-8'
                >
                  {isExporting ? '正在' : ''}生成报告
                </Button>
              </>
              : <></>
          }
          {
            isXTC && (
              <>
                {/* 小天才项目报告：仅 Mall 详情（小圈）显示；「查看」默认隐藏，导出成功(showDownloadBtn)后才透出（#54） */}
                {isMallType && viewXtcProjectPerm && showDownloadBtn
                  ? <Button onClick={methods.viewXtcProjectReport} className='ml-8'>
                    {viewXtcProjectPerm.name || '查看项目报告'}
                  </Button>
                  : <></>
                }
                {isMallType && exportXtcProjectPerm
                  ? <Button
                    loading={isExportingXtcProject}
                    onClick={methods.exportXtcProjectReport}
                    className='inline-block ml-8'
                  >
                    {isExportingXtcProject ? '正在导出报告' : (exportXtcProjectPerm.name || '导出项目报告')}
                  </Button>
                  : <></>
                }
                {/* 小天才商圈报告：仅商圈详情（大圈）显示；「查看」默认隐藏，导出成功(showDownloadBtn)后才透出（#54） */}
                {!isMallType && viewXtcMallPerm && showDownloadBtn
                  ? <Button onClick={methods.viewXtcMallReport} className='ml-8'>
                    {viewXtcMallPerm.name || '查看商圈报告'}
                  </Button>
                  : <></>
                }
                {!isMallType && exportXtcMallPerm
                  ? <Button
                    loading={isExportingXtcMall}
                    onClick={methods.exportXtcMallReport}
                    className='inline-block ml-8'
                  >
                    {isExportingXtcMall ? '正在导出报告' : (exportXtcMallPerm.name || '导出商圈报告')}
                  </Button>
                  : <></>
                }
              </>
            )
          }
          {
            detail?.orderAndCase ? <div className='ml-8'>
              <Button
                onClick={methods.jumpToTarget}
              >
              案例及订单
              </Button>
            </div> : <></>
          }
          {/* {
            historyTaskPermission && <Tooltip title={`历史${expansionTaskAlias || '任务'}`}>
              <div
                onClick={() => {
                  setHistoryVisible(true);
                  bigdataFn('b472312e-ebed-4edb-8ae2-56d3164876dc', '详情-任务历史', '点击了详情-任务历史', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
                }}
                className={cs(styles.historyBtn, 'ml-8')}>
                <IconFont iconHref='iconic_lishirenwu' className={styles.icon} />
              </div>
            </Tooltip>
          } */}
          {
            historyTaskPermission &&
              <div
                className='ml-8'>
                <Button
                  onClick={() => {
                    setHistoryVisible(true);
                    // bigdataFn('b472312e-ebed-4edb-8ae2-56d3164876dc', '详情-任务历史', '点击了详情-任务历史', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
                  }}
                >
                  {`历史${expansionTaskAlias || '任务'}`}
                </Button>
              </div>
          }
          {
            createTaskPermission && <CreateTask
              id={id}
              needApproval={detail?.needTaskApproval}
              expansionTaskAlias={expansionTaskAlias}
              btnTitle={taskConfigObj.btnTitle}
              btnConfig={{
                disabled: taskConfigObj.disabled,
                // 当配置了集客点时，让拓店任务按钮设为默认颜色
                type: gatherClientPoint?.permissionConfig?.isPermission ? 'default' : 'primary',
              }}
              className = 'ml-8'
              setShowCreateDrawer={setShowCreateDrawer}
              onCreateSuccess={methods.onCreateSuccess}
              modelConfigId={modelConfigId}
              isTaskProcessing={taskConfigObj.isTaskProcessing}
            />
          }
          {/* 集客点按钮展示权限与状态 */}
          {
            gatherClientPoint?.permissionConfig?.isPermission ? <Button
              disabled={gatherClientPoint?.disabled}
              type='primary'
              onClick={() => {
                setGatherClientPointDrawer({
                  visible: true,
                  value: detail
                });
              }}
              className='inline-block ml-8'
            >
              {gatherClientPoint?.permissionConfig?.text}
            </Button> : <></>
          }
          {/* 编辑商圈权限及按钮 */}
          {
            editPermission ? <Button
              type='primary'
              onClick={() => {
                setEditModalData({
                  open: true,
                  // 优先取编辑后的回显
                  data: editModalData?.data || {},
                });
              }}
              className='inline-block ml-8'
            >
              {editPermission?.name }
            </Button> : <></>
          }
          {/* 按钮展示的判断逻辑 */}
          {
            showAIButton && <div
              className={cs(styles.AICon, isStartAnalyseOfAI ? styles.isDisabled : '')}
              onClick={() => {
                if (isStartAnalyseOfAI) return;
                setIsStartAnalyseOfAI(true);
              }}
            >
              <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/ai/icon_ai_button@2x.png`}
                width='100%'
                height='100%'
              />
            </div>
          }
        </div>}
      </div>
      {/* 标签行 */}
      <LabelRow
        id={id}
        detail={detail}
        overViewData={overViewData}
        editable={!hideTopActions}
        onLabelChanged={onLabelChanged}
        labelOptionsChanged={labelOptionsChanged}
        style={{ maxWidth: '85%' }}
      />
      {/* 数据说明弹窗 */}
      {
        [1, 2].includes(showDataDescriptionFlag) && (
          <DataInfoModal
            open={openDataInfo}
            setOpen={setOpenDataInfo}
            markType={overViewData?.markType}
            isSemirModel={isSemirModel}
            dataDescription={detail.dataDescription}
            showDataDescriptionFlag={showDataDescriptionFlag}
          />
        )
      }
      {/* 集客点录入弹窗 */}
      {gatherClientPoint?.permissionConfig?.isPermission
        ? <GatherClientDrawer
          open={gatherClientPointDrawer}
          setOpen={setGatherClientPointDrawer}
          onRefresh={onRefreshGather}
        />
        : <></>}
      <EditFormModal
        id={id}
        openingAreaAlias={openingAreaAlias}
        modalData={editModalData}
        setModalData={setEditModalData}
      />
      {/* 商圈不合适标记弹窗 */}
      <AreaMarkingModal
        modalData={markingModal}
        onClose={() => setMarkingModal({ open: false, data: { modelClusterId: null, areaName: '' } })}
        onSuccess={getDetail}
      />
      <AllTaskDetailDrawer
        onRefresh={onRefreshGather}
        detailDrawerData={expandStoreDrawerData}
        setShowDetailDrawer={setExpandStoreDrawerData}/>
      {/* 编辑商圈名称弹窗 */}
      <Modal
        title='编辑名称'
        open={editAreaNameVisible}
        onOk={methods.handleEditAreaNameOk}
        onCancel={methods.handleEditAreaNameCancel}
        destroyOnClose
      >
        <V2Form form={editAreaNameForm}>
          <V2FormInput
            label='商圈名称'
            name='areaName'
            required
            maxLength={30}
            rules={[{ required: true, message: '请输入商圈名称' }]}
            config={{ ref: editAreaNameInputRef }}
          />
        </V2Form>
      </Modal>
    </div>
  );
};

export default Top;
